<template>
  <div>
    <Header v-if="!isPage('detail')"/>
    <Nav
        v-if="(isPage('todo') || isPage('doing') || isPage('done') || isPage('flow_cc')|| isPage('apply'))"/>
    <div>
      <router-view v-if="RouterShow"/>
    </div>
    <a-back-top/>
  </div>
</template>

<script>
import {myMixin} from "@/mixins/tool.js";
import Header from "./header";
import Nav from "./nav";

export default {
  name: "mobile",
  components: {
    Nav,
    Header,
  },
  mixins: [myMixin]
};
</script>
<style lang="css">
@import "~@/assets/todoCenter/default/css/wechat.css";
</style>
<style>
.mobile {
  max-width: 500px;
  margin: 0px auto;
  overflow: hidden;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/wechat/layout/index.vue